---
id: go-shared-resumes
title: Shared resume normalizer
owner: Backend Team
status: Active
lastReviewed: 2026-01-30
visibility: internal
tags:
  - resume
  - normalization
  - shared
---

## Product Overview

### Who it serves

This shared package supports services that need to transform resume documents into a consistent relational shape for storage or downstream processing.

### Primary workflow

Callers pass a resume document map and an ID into the normalizer, which produces a structured resume representation with normalized sections.

### Business rules

Normalization sanitizes string inputs, preserves ordering metadata, and applies defaults for optional section visibility and chronology flags.

### Outcomes

Downstream systems receive a stable, typed resume representation suitable for persistence and analytics.

### Out of scope

Resume editing, scoring, and rendering logic are handled by service-specific packages.

## Technical Overview

### Architecture flow

`NormalizeResumeData` iterates through document fields, maps them into `ResumePG`, and delegates section arrays to specialized normalizers.

### Entry points

The main entry point is `NormalizeResumeData` in `apps/micro-services/go-shared/resumes/nomalizer.go`, which returns a `ResumePG` record plus normalized section lists.

### Key modules

`nomalizer.go` defines the `ResumePG` schema and section types, plus helpers like `sanitizeString`, `toNullString`, and section-specific normalizers for awards, education, experience, projects, skills, and related collections.

### Data sources and sinks

The function consumes Firestore-style resume documents and outputs SQL-friendly structures designed for persistence layers.

### Integrations and side effects

The normalizer logs warnings on unexpected input types and guards against panics to keep batch processing resilient.

### Constraints and risks

Input schema drift can lead to missing fields or defaulted values, so callers must keep document shapes aligned with the expected resume schema.

## Changelog

- 2026-01-30: Initial documentation.
